import validate from 'lib/utils/validationRules';

class Attachment {
  constructor(data = {}) {
    this.createdAt = data?.created_at || null;
    this.hash = data?.hash || null;
    this.id = data?.id || null;
    this.link = data?.link || null;
    this.name = data?.name || null;
  }

  getData() {
    if (validate.isNull(this.id)) {
      return null;
    }

    return {
      created_at: this.createdAt,
      hash: this.hash,
      id: this.id,
      link: this.link,
      name: this.name,
    };
  }

  setData(data) {
    this.createdAt = data?.created_at;
    this.hash = data?.hash;
    this.id = data?.id;
    this.link = data?.link;
    this.name = data?.name;
  }

  reset() {
    this.createdAt = null;
    this.hash = null;
    this.id = null;
    this.link = null;
    this.name = null;
  }
}

export default Attachment;
